import {
  ActionReducerMapBuilder,
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";
import { Template, TemplatesResult } from "../interfaces/templates.types.ts";
import {
  addTemplatesToFolder,
  fetchAllTemplates,
  fetchTemplateByID,
  getTemplatesNotInFolder,
} from "../actions/templatesActions.tsx";

export interface TemplatesState extends TemplatesResult {
  loading: boolean;
  error: string | undefined;
  newTemplates: Template[];
  activeTemplate: Template | null;
  tagColors: { [key: string]: string };
}

const initialState = {
  count: 0,
  next: null,
  previous: null,
  results: [],
  loading: false,
  error: undefined,
  newTemplates: [],
  activeTemplate: null,
  tagColors: {},
} satisfies TemplatesState as TemplatesState;

const templatesSlice = createSlice({
  name: "templates",
  initialState,
  reducers: {
    setTemplateTagColors: (
      state,
      action: PayloadAction<{ [key: string]: string }>,
    ) => {
      state.tagColors = action.payload;
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<TemplatesState>) => {
    builder
      .addCase(fetchAllTemplates.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchAllTemplates.fulfilled, (state, action) => {
        state.loading = false;
        state.count = action.payload.count;
        state.next = action.payload.next;
        state.previous = action.payload.previous;
        state.results = action.payload.results;
      })

      .addCase(getTemplatesNotInFolder.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(
        getTemplatesNotInFolder.fulfilled,
        (state, action: PayloadAction<Template[]>) => {
          state.loading = false;
          state.newTemplates = action.payload;
        },
      )

      .addCase(addTemplatesToFolder.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(addTemplatesToFolder.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addTemplatesToFolder.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchTemplateByID.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })

      .addCase(
        fetchTemplateByID.fulfilled,
        (state, action: PayloadAction<Template>) => {
          state.loading = false;
          state.activeTemplate = action.payload;
        },
      );
  },
});

export const { setTemplateTagColors } = templatesSlice.actions;
export default templatesSlice.reducer;
